import React, { useRef } from "react";
import "./newsletter.css";
import emailjs from "@emailjs/browser";

export default function Newsletter() {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    var message = emailjs.message.create({
      template: process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
    });

    message.attach({
      name: "earbud.png", // Provide a name for the attached image file
      data: "data:image/png;base64,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", // Replace with the base64-encoded image data
      type: "image/png", // Specify the image type
      headers: { "Content-ID": "earbud" }, // Match the CID in your HTML template
    });

    emailjs
      .sendForm(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        { message },
        form.current,
        process.env.REACT_APP_EMAILJS_PUBLIC_KEY
      )
      .then(
        (result) => {
          console.log(result.text);
        },
        (error) => {
          console.log(error.text);
        }
      );
    alert("Email Sent!");
    e.target.reset();
  };

  return (
    <div className="discount-container">
      <section className="discount-content !tracking-[-0.025em]">
        <h3>Get access to Exclusive Deals & Discounts</h3>
        <p className="!font-light">
        Sign up for our newsletter to receive exclusive codes and save money on special promotions. Join our community today and enjoy the benefits.
        </p>
        <form onSubmit={sendEmail} ref={form}>
          <label htmlFor="email">Email:</label>
          <input
            type="email"
            id="email"
            name="user_email"
            placeholder="name@email.com"
            required
          />
          {/* <button type="submit" value="Send">
            Get Discount
          </button> */}
        </form>
      </section>
    </div>
  );
}
